import React, { FC } from 'react'
import { DropdownMenuItemGroup } from './types'
import { ItemGroupHeader } from './Item.styles'
import { renderItem } from './Item'
import { ContextMenu } from '../ContextMenu'
import { hasSubItems } from '../utils'

export type Props = {
  item: DropdownMenuItemGroup
  leaveSpaceForSubmenu: boolean
}

const ItemGroup: FC<Props> = ({ item }) => {
  const { submenuItems, groupSubitems, label } = item
  const subitemsExist = hasSubItems(item)

  return (
    <div>
      <ItemGroupHeader>
        {label}
        {submenuItems && submenuItems.length && <ContextMenu items={submenuItems} />}
      </ItemGroupHeader>
      {groupSubitems.map(item => renderItem(item, subitemsExist))}
    </div>
  )
}

export default ItemGroup
export type ItemGroupProps = Props
